import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import images from "../../../../../../utilities/images/images";
import "./CreateNewDoubtBtn.scss";
import axios from "axios";
import { url_262 } from "../../../../../../custom_utilities/api_services";
import { connect } from "react-redux";
import CustomModal from "../../../../../../custom_utilities/Modal/CustomModal";
import { toastifyMessage } from "../../../../../../custom_utilities/toastify_config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateNewDoubtBtn = (props) => {
  const { handleShow, userData, history } = props;
  const savedResponse = JSON.parse(localStorage.getItem("doubtResponse"));

  const [activeButton, setActiveButton] = useState("connectWithTutor");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    description: "",
  });
  const [isSubscribed, setIsSubscribed] = useState(true);

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  const handleImageClick = (e) => {
    e.stopPropagation();

    setModalContent({
      title: "About Connect with Tutor",
      description:
        "Get 1-on-1 doubt-solving support from IIT & AIIMS tutors. Just scan, type, or upload your question, and a tutor will connect in real time to provide a clear solution.",
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsSubscribed(true);
  };
  const getConnectTutor = async (userData) => {
    try {
      const response = await axios.get(
        `${url_262}?user_id=${userData?.user_id}`
      );
      if (response.status === 200) {
        toastifyMessage({
          status: "success",
          message: response.data.message || "Successfully connected",
        });
        const sessionUrl = response.data.session_url;
        if (sessionUrl) {
          setTimeout(() => {
            history.push({
              pathname: "/tutor-session",
              state: { sessionUrl },
            });
          }, 1000);
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        const errorMessage = error.response.data.message || "An error occurred";
        toastifyMessage({
          status: "error",
          message: errorMessage,
        });
        setTimeout(() => {
          history.push({
            pathname: "/store",
            state: { setActiveTab: 4 },
          });
        }, 1000);
      } else {
        toastifyMessage({
          status: "error",
          message: error.message,
        });
      }
    }
  };

  const handleConnectWithTutorClick = () => {
    handleButtonClick("connectWithTutor");

    const isSubscribedFlag = Boolean(
      savedResponse?.data?.is_connect_tutor_subscribe
    );

    if (isSubscribedFlag) {
      setIsSubscribed(false);
      const message = savedResponse?.data?.message;
      setModalContent({
        title: message?.title,
        description: message?.description,
      });
      setIsModalOpen(true);
      return;
    }

    localStorage.removeItem("doubtResponse");
    getConnectTutor(userData);
  };

  const handleBuyNow = () => {
    history.push(`/package/${savedResponse?.data?.package_id}`);
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        outine
        pauseOnHover
        draggable={false}
        style={{ zIndex: 9999 }}
      />

      <div
        style={{
          display: "flex",
          margin: "0px auto 3.2rem",
          gap: "16px",
          justifyContent: "center",
        }}
      >
        {userData?.UsertargetDetail?.some((e) =>
          [1, 2, 3].includes(e.target_id)
        ) && (
          <div>
            <button
              className={`tutor_button ${
                activeButton === "connectWithTutor" ? "active" : "inactive"
              }`}
              onClick={handleConnectWithTutorClick}
            >
              Connect with Tutor
              <img
                style={{ marginLeft: "10px", width: "16px", height: "16px" }}
                src={
                  activeButton === "connectWithTutor"
                    ? images.new_report1
                    : images.new_report
                }
                alt="Info Icon"
                onClick={handleImageClick}
              />
            </button>
          </div>
        )}

        <div>
          <button
            className={`tutor_button ${
              activeButton === "connectNewDoubt" ? "active" : "inactive"
            }`}
            onClick={() => {
              handleButtonClick("connectNewDoubt");
              handleShow();
            }}
          >
            Create a New Doubt
          </button>
        </div>
      </div>

      {/* Modal */}
      <CustomModal
        isOpen={isModalOpen}
        closeModal={closeModal}
        title={modalContent.title}
        hideXIcon={false}
        width="500px"
        height="310px"
      >
        <div style={{ textAlign: "center" }}>
          <p>{modalContent.description}</p>

          {!isSubscribed && (
            <button
              onClick={handleBuyNow}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                backgroundColor: "#b50503",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              Buy Now
            </button>
          )}
        </div>
      </CustomModal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.auth.user,
  };
};

export default connect(mapStateToProps)(withRouter(CreateNewDoubtBtn));
